const Utils = {
  baseUrl:
    location.hostname === "localhost"
      ? "https://dev.euphonic.co.jp"
      : location.origin,

  getHeaderHeight(): number {
    // const globalHeader =
    //   document
    //     .querySelector<HTMLElement>("header[data-id='global-header']")
    //     ?.getBoundingClientRect().height || 0;
    const globalHeader = 50;
    return globalHeader;
  },

  contentHeight(postfix?: string): string {
    return `${window.innerHeight - Utils.getHeaderHeight()}${postfix}`;
  },

  async isLogin(): Promise<boolean> {
    const response = await fetch(`${this.baseUrl}/virtual/app/loginCheck.php`, {
      method: "POST",
    });
    const data = await response.json();
    return data === 1;
  },

  async isFirstLogin(): Promise<boolean> {
    const loginDate = localStorage.getItem("last-login-date");
    const ret = loginDate ? false : true;

    const response = await fetch(
      `${this.baseUrl}/virtual/app/lookupMember.php`,
      {
        method: "POST",
      }
    );
    const data = await response.json();
    localStorage.setItem("last-login-date", data["857"]);
    return ret;
    // const date = new Date(data["857"]);
    // date.setHours(0, 0, 0, 0);
    // const lastLoginDate = date.getTime().toString();
    // let isFirstLogin = true;
    // if (loginDate && lastLoginDate === loginDate) {
    //   isFirstLogin = false;
    // }
    // localStorage.setItem("last-login-date", lastLoginDate);
    // return isFirstLogin;
  },

  async getName(): Promise<string> {
    const response = await fetch(
      `${this.baseUrl}/virtual/app/lookupMember.php`,
      {
        method: "POST",
      }
    );
    const data = await response.json();
    return data["852"];
  },

  async logout(): Promise<void> {
    const response = await fetch(`${this.baseUrl}/virtual/app/logout.php`, {
      method: "POST",
    });
    const data = await response.json();
    return data;
  },

  async getRemainingLotteryTimes(): Promise<number> {
    const response = await fetch(
      `${this.baseUrl}/virtual/app/getRemainingLotteryTimes.php`,
      {
        method: "POST",
      }
    );
    const data = await response.json();
    return Number.isInteger(data) ? parseInt(data) : 0;
  },

  async getCampaign(): Promise<Array<Campaign>> {
    const response = await fetch(
      `${this.baseUrl}/virtual/app/getCampaignStatus.php`,
      {
        method: "POST",
      }
    );
    const apiList = await response.json();

    const file = await fetch(`campaign/config.json?${Date.now()}`);
    if (file.status !== 200) {
      return [];
    }
    const fileList = await file.json();

    const defaultType = "NewMemberCampaign";
    const list = [];
    for (const item of apiList) {
      const shortDate = (str: string) => str.substring(0, 7);
      const c = fileList.find(
        (v: any) => v.id === item.id && v.date === shortDate(item.nowDateTime)
      );
      // if (!c) c = fileList.find((v: any) => v.id === item.id);

      if (c) {
        item.type = c.type || defaultType;
        item.list = c.list;
        item.terms = c.terms;
      } else if (item.id === "new_register_2023") {
        item.type = defaultType;
      }

      if ((item.canApply || item.isApply) && item.type) list.push(item);
    }

    return list;
  },

  async sendCampaign(data: FormData): Promise<any> {
    const response = await fetch(
      `${this.baseUrl}/virtual/app/applyCampaign.php`,
      {
        method: "POST",
        body: data,
      }
    );
    if (response.status !== 200) return 0;
    const txt = await response.text();
    return txt === "true";
  },

  async getNotice(): Promise<any> {
    const noData = {
      show: false,
      messages: [],
    };

    const response = await fetch(`notice.json?${Date.now()}`);

    if (response.status !== 200) return noData;

    const data = await response.json();
    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);
    const now = new Date();
    if (now < startDate || now > endDate) return noData;

    const noticeDate = localStorage.getItem("notice.date");
    const today = `${now.getFullYear()}${now.getMonth()}${now.getDate()}`;
    if (noticeDate) return noData;
    localStorage.setItem("notice.date", today);

    return {
      show: true,
      messages: data.messages,
    };
  },

  todayFirstLogin(): boolean {
    const now = new Date();
    const today = `${now.getFullYear()}${now.getMonth()}${now.getDate()}`;
    const loginDate = localStorage.getItem("virtual.login-date");
    if (today === loginDate) return false;

    localStorage.setItem("virtual.login-date", today);
    return true;
  },
};

export default Utils;
